import styled from "styled-components";

export const Container = styled.div``;

export const Label = styled.label``;

export const DateWithTimeInput = styled.input`
  margin: 5px;
`;
